import { render, staticRenderFns } from "./WorkflowPass.vue?vue&type=template&id=6695a371&scoped=true"
import script from "./WorkflowPass.vue?vue&type=script&lang=js"
export * from "./WorkflowPass.vue?vue&type=script&lang=js"
import style0 from "./WorkflowPass.vue?vue&type=style&index=0&id=6695a371&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6695a371",
  null
  
)

export default component.exports